import React from "react";

export const DatabaseIcon = ({ width = "24", height = "24", fill = "currentColor" }) => (
    <svg width={`${width}px`} height={`${height}px`} strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#32ffff">
        <path d="M14 19L17 22L22 17" stroke="#32ffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M4 6V12C4 12 4 15 11 15C18 15 18 12 18 12V6" stroke="#32ffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M11 3C18 3 18 6 18 6C18 6 18 9 11 9C4 9 4 6 4 6C4 6 4 3 11 3Z" stroke="#32ffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M11 21C4 21 4 18 4 18V12" stroke="#32ffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
)